import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import usePreviousRoute from "../../hooks/usePreviousRoute";

const ScrollManager = () => {
  const location = useLocation();
  const prevRoute = usePreviousRoute();
  const scrollPositions = useRef({});

  useEffect(() => {
    const saveScrollPosition = () => {
      scrollPositions.current[location.pathname] = window.scrollY;
      sessionStorage.setItem(
        "scrollPositions",
        JSON.stringify(scrollPositions.current)
      );
    };

    window.addEventListener("scroll", saveScrollPosition);

    return () => {
      window.removeEventListener("scroll", saveScrollPosition);
    };
  }, [location.pathname, scrollPositions]);

  useEffect(() => {
    if (location.pathname.includes("details")) return;
    const scrollPositions = JSON.parse(
      sessionStorage.getItem("scrollPositions") || "{}"
    );
    const pos = scrollPositions?.[location.pathname] || 0;
    setTimeout(() => {
      if (prevRoute?.pathname?.includes("details")) {
        window.scrollTo(0, pos);
      }
    }, 100);
  }, [location.pathname, prevRoute]);

  return null;
};

export default ScrollManager;
